import React, { useState } from 'react'
import { styled, alpha } from '@mui/material/styles'
import AppBar from '@mui/material/AppBar'
import Box from '@mui/material/Box'
import Toolbar from '@mui/material/Toolbar'
import IconButton from '@mui/material/IconButton'
import Typography from '@mui/material/Typography'
import InputBase from '@mui/material/InputBase'
import Blockchains from '../Navbar/SubNav/Blockchains'
import Validators from '../Navbar/SubNav/Validators'
import { Button, CardMedia } from '@mui/material'
import logo from '../../Image/logo512.png'
import dexitLogo from '../../Image/logo.svg'
import { ethers } from 'ethers'
import { useLocation, useNavigate } from 'react-router-dom'
import MoreIcon from '@mui/icons-material/MoreVert'
import MenuItem from '@mui/material/MenuItem'
import Menu from '@mui/material/Menu'
import MenuIcon from '@mui/icons-material/Menu'
import { GifBox } from '@mui/icons-material'
import metaMaskLogo from '../../Image/metamask.svg'
import { useWeb3Context } from '../../hooks/web3Context'
import Voting from '../Navbar/SubNav/Voting'
import Connect from '../Navbar/SubNav/Connect'
import Contract from '../Navbar/SubNav/Contract'

const Header3 = () => {
  const { connect, disconnect, address } = useWeb3Context()
  const [anchorEl, setAnchorEl] = React.useState(null)
  const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = React.useState(null)
  const navigate = useNavigate()
  const location = useLocation()
  const isMenuOpen = Boolean(anchorEl)
  const isMobileMenuOpen = Boolean(mobileMoreAnchorEl)
  const [errorMessage, setErrorMessage] = useState(null)
  const [defaultAccount, setDefaultAccount] = useState(null)
  const [userBalance, setUserBalance] = useState(null)
  const [connButtonText, setConnButtonText] = useState('Connect Wallet')
  const handleProfileMenuOpen = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handleMobileMenuClose = () => {
    setMobileMoreAnchorEl(null)
  }

  const handleMenuClose = () => {
    setAnchorEl(null)
    handleMobileMenuClose()
  }

  const handleMobileMenuOpen = (event) => {
    setMobileMoreAnchorEl(event.currentTarget)
  }

  const connectWalletHandler = () => {
    if (window.ethereum && window.ethereum.isMetaMask) {
      console.log('MetaMask Here!')

      window.ethereum
        .request({ method: 'eth_requestAccounts' })
        .then((result) => {
          accountChangedHandler(result[0])
          setConnButtonText('Wallet Connected')
          getAccountBalance(result[0])
        })
        .catch((error) => {
          setErrorMessage(error.message)
        })
    } else {
      console.log('Need to install MetaMask')
      setErrorMessage('Please install MetaMask browser extension to interact')
    }
  }

  // update account, will cause component re-render
  const accountChangedHandler = (newAccount) => {
    setDefaultAccount(newAccount)
    getAccountBalance(newAccount.toString())
  }

  const getAccountBalance = (account) => {
    window.ethereum
      .request({ method: 'eth_getBalance', params: [account, 'latest'] })
      .then((balance) => {
        setUserBalance(ethers.utils.formatEther(balance))
      })
      .catch((error) => {
        setErrorMessage(error.message)
      })
  }

  const chainChangedHandler = () => {
    // reload the page to avoid any errors with chain change mid use of application
    window.location.reload()
  }

  try {
    window.ethereum.on('accountsChanged', accountChangedHandler)

    window.ethereum.on('chainChanged', chainChangedHandler)
  } catch (error) {
    console.log(error)
  }
  // listen for account changes

  const handleRoute = () => {
    navigate('/staking')
  }

  const handleHome = () => {
    navigate('/')
  }

  const handleBlock = () => {
    navigate('/allblocks')
  }

  const handleVoting = () => {
    navigate('/voting')
  }

  const handleFaucet = () => {
    navigate('/faucet')
  }

  const mobileMenuId = 'primary-search-account-menu-mobile'

  const renderMobileMenu = (
    <Menu
      anchorEl={mobileMoreAnchorEl}
      id={mobileMenuId}
      keepMounted
      open={isMobileMenuOpen}
      onClose={handleMobileMenuClose}
    >
      <MenuItem>
        <IconButton
          size="large"
          aria-label="show 4 new mails"
          color="inherit"
          onClick={() => handleHome()}
          className="nav-button-mobile"
        >
          Home
        </IconButton>
      </MenuItem>

      <MenuItem>
        <IconButton
          size="large"
          aria-label="show 4 new mails"
          color="inherit"
          onClick={() => handleStack()}
          className="nav-button-mobile"
        >
          Stake
        </IconButton>
      </MenuItem>

      <MenuItem>
        <IconButton
          size="large"
          aria-label="show 4 new mails"
          color="inherit"
          onClick={() => handleUnStack()}
          className="nav-button-mobile"
        >
          UnStake
        </IconButton>
      </MenuItem>

      <MenuItem>
        <IconButton
          size="large"
          aria-label="show 4 new mails"
          color="inherit"
          onClick={() => handleBlock()}
          className="nav-button-mobile"
        >
          Blocks
        </IconButton>
      </MenuItem>

      {/* <MenuItem>
        <IconButton
          size="large"
          aria-label="show 4 new mails"
          color="inherit"
          onClick={() => handleFaucet()}
        >
          <span
            style={{ fontSize: '0.875rem', color: '#8997B1', padding: '6px' }}
          >
            Faucet
          </span>
        </IconButton>
      </MenuItem> */}

      {/* <MenuItem>
        <IconButton
          size="large"
          aria-label="show 4 new mails"
          color="inherit"
          onClick={() => handleSwap()}
        >
          <span
            style={{ fontSize: '0.875rem', color: '#8997B1', padding: '6px' }}
          >
            Swap
          </span>
        </IconButton>
      </MenuItem> */}

      <MenuItem>
        <Voting />
      </MenuItem>
      <MenuItem>
        <Contract />
      </MenuItem>

      {/* <MenuItem>
          <IconButton
            size="large"
            aria-label="show 4 new mails"
            color="inherit"
            onClick={()=>handleVoting()}
          >
            <span style={{ fontSize: "13px", textTransform: "uppercase" }}>
            Voting
            </span>
          </IconButton>
        </MenuItem> */}

      {/* <MenuItem>
        <IconButton
          size="large"
          aria-label="show 17 new notifications"
          color="inherit"
          onClick={()=>handleVoting()}
        >
          <span style={{ fontSize: "13px", textTransform: "uppercase" }}>
            Voting
          </span>
          <Blockchains />
        </IconButton>
      </MenuItem> */}
      <MenuItem>
        <Validators />
      </MenuItem>

      {/* <MenuItem>
        <IconButton
          size="large"
          aria-label="show 17 new notifications"
          color="inherit"
        >
          <Connect />
        </IconButton>
      </MenuItem> */}

      {/* <MenuItem>
        <IconButton
          size="large"
          aria-label="show more"
          aria-haspopup="true"
          onClick={connectWalletHandler}
          color="inherit"
        >
          <CardMedia component="img" height="50" image={metaMaskLogo} />
        </IconButton>
      </MenuItem> */}
    </Menu>
  )

  const handleStack = () => {
    navigate('/staking')
  }

  const handleUnStack = () => {
    navigate('/unstaking')
  }

  const handleSwap = () => {
    navigate('/swap')
  }

  const navigatRoute = () => {
    navigate('/')
  }

  return (
    <Box sx={{ flexGrow: 1, background: '#2C2E3F' }}>
      <AppBar
        position="static"
        sx={{
          background: 'transparent',
          color: '#8997B1',
          boxShadow: 'none',
          maxWidth: '1200px',
          margin: 'auto',
        }}
      >
        <Toolbar>
          <Box sx={{ display: { xs: 'flex', md: 'none' } }}>
            <IconButton
              size="large"
              aria-label="show more"
              aria-controls={mobileMenuId}
              aria-haspopup="true"
              onClick={handleMobileMenuOpen}
              color="inherit"
            >
              <MenuIcon />
            </IconButton>
          </Box>
          <Box
            size="large"
            edge="start"
            color="inherit"
            // aria-label="open drawer"
            onClick={navigatRoute}
            sx={{
              cursor: 'pointer',
            }}
          >
            <img src={dexitLogo} alt="dexitlogo" style={{ width: '120px' }} />
          </Box>
          <Box sx={{ flexGrow: 1 }} />
          <Box
            sx={{
              mx: 2,
              display: { xs: 'none', lg: 'flex', alignItems: 'center' },
            }}
          >
            <Button
              id="demo-customized-button"
              onClick={() => handleHome()}
              disableElevation
              className="nav-button"
            >
              Home
            </Button>

            <Button
              id="demo-customized-button"
              disableElevation
              className="nav-button"
              onClick={handleStack}
            >
              Stake
            </Button>

            <Button
              id="demo-customized-button"
              disableElevation
              className="nav-button"
              onClick={handleUnStack}
            >
              UnStake
            </Button>

            <Button
              id="demo-customized-button"
              onClick={() => handleBlock()}
              disableElevation
              className="nav-button"
            >
              Blocks
            </Button>

            {/* <Button
              id="demo-customized-button"
              onClick={() => handleFaucet()}
              disableElevation
              className="nav-button"
            >
              Faucet
            </Button> */}

            {/* <Button
              id="demo-customized-button"
              onClick={() => handleSwap()}
              disableElevation
              className="nav-button"
            >
              Swap
            </Button> */}

            <Box>
              <Voting />
            </Box>

            {/* <Button
              id="demo-customized-button"
              onClick={()=>handleVoting()}
              disableElevation
              sx={{ border: "none", color: "#8997B1" }}
            >
              Voting
            </Button> */}

            {/* <Box
              size="large"
              aria-label="show 17 new notifications"
              color="inherit"
              onClick={()=>handleVoting()}
            >
            Voting
            </Box> */}
            <Box>
              <Contract />
            </Box>
            <Box>
              <Validators />
            </Box>

            {/* <Box >
              <Connect />
            </Box> */}

            {/* <IconButton
              size="large"
              aria-label="show more"
              aria-haspopup="true"
              onClick={connectWalletHandler}
              color="inherit"
            >
              <CardMedia component="img" height="50" image={metaMaskLogo} />
            </IconButton> */}
          </Box>

          {!address ? (
            <Button
              color="primary"
              className="blocksBtn connect-button"
              variant="contained"
              onClick={connect}
              size="large"
            >
              Connect
            </Button>
          ) : (
            <Button
              color="primary"
              className="blocksBtn connect-button"
              variant="contained"
              onClick={disconnect}
              size="large"
            >
              Disconnect
            </Button>
          )}
        </Toolbar>
      </AppBar>
      {renderMobileMenu}
    </Box>
  )
}

export default Header3
